module.exports = __webpack_public_path__ + "img/DecisionTreeOwned.6f38dc7e.png";